// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WtbOpsControlRouteImport } from './routes/wtb-ops-control'
import { Route as VerifiedStoresRouteImport } from './routes/verified-stores'
import { Route as TrustRouteImport } from './routes/trust'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SellerPolicyRouteImport } from './routes/seller-policy'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RatingPolicyRouteImport } from './routes/rating-policy'
import { Route as PoliciesRouteImport } from './routes/policies'
import { Route as PlatformPoliciesRouteImport } from './routes/platform-policies'
import { Route as PaymentSafetyRouteImport } from './routes/payment-safety'
import { Route as FeesRouteImport } from './routes/fees'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as CreateOrderRouteImport } from './routes/create-order'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as ConditionGuideRouteImport } from './routes/condition-guide'
import { Route as BannedAccountsRouteImport } from './routes/banned-accounts'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AuthenticatedRouteRouteImport } from './routes/_authenticated/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ProfileUsernameRouteImport } from './routes/profile.$username'
import { Route as OrdersIdRouteImport } from './routes/orders.$id'
import { Route as DemoIdRouteImport } from './routes/demo.$id'
import { Route as AuthenticatedWishlistRouteImport } from './routes/_authenticated/wishlist'
import { Route as AuthenticatedSoldItemsRouteImport } from './routes/_authenticated/sold-items'
import { Route as AuthenticatedSellerVerificationRouteImport } from './routes/_authenticated/seller-verification'
import { Route as AuthenticatedSellerHubRouteImport } from './routes/_authenticated/seller-hub'
import { Route as AuthenticatedRecentlyViewedRouteImport } from './routes/_authenticated/recently-viewed'
import { Route as AuthenticatedPurchasesRouteImport } from './routes/_authenticated/purchases'
import { Route as AuthenticatedPriceAlertsRouteImport } from './routes/_authenticated/price-alerts'
import { Route as AuthenticatedPaymentsRouteImport } from './routes/_authenticated/payments'
import { Route as AuthenticatedNotificationsRouteImport } from './routes/_authenticated/notifications'
import { Route as AuthenticatedMyListingsRouteImport } from './routes/_authenticated/my-listings'
import { Route as AuthenticatedFulfillmentCartRouteImport } from './routes/_authenticated/fulfillment-cart'
import { Route as AuthenticatedDashboardRouteImport } from './routes/_authenticated/dashboard'
import { Route as AuthenticatedCollectionRouteImport } from './routes/_authenticated/collection'
import { Route as AuthenticatedBidsRouteImport } from './routes/_authenticated/bids'
import { Route as AuthenticatedAccountRouteImport } from './routes/_authenticated/account'
import { Route as AuthenticatedMessagesIndexRouteImport } from './routes/_authenticated/messages.index'
import { Route as AuthenticatedTransactionIdRouteImport } from './routes/_authenticated/transaction.$id'
import { Route as AuthenticatedMessagesThreadIdRouteImport } from './routes/_authenticated/messages.$threadId'
import { Route as AuthenticatedCheckoutTransactionIdRouteImport } from './routes/_authenticated/checkout.$transactionId'

const WtbOpsControlRoute = WtbOpsControlRouteImport.update({
            id: '/wtb-ops-control',path: '/wtb-ops-control',getParentRoute: () => rootRouteImport
          })
const VerifiedStoresRoute = VerifiedStoresRouteImport.update({
            id: '/verified-stores',path: '/verified-stores',getParentRoute: () => rootRouteImport
          })
const TrustRoute = TrustRouteImport.update({
            id: '/trust',path: '/trust',getParentRoute: () => rootRouteImport
          })
const TermsRoute = TermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => rootRouteImport
          })
const SellerPolicyRoute = SellerPolicyRouteImport.update({
            id: '/seller-policy',path: '/seller-policy',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const RatingPolicyRoute = RatingPolicyRouteImport.update({
            id: '/rating-policy',path: '/rating-policy',getParentRoute: () => rootRouteImport
          })
const PoliciesRoute = PoliciesRouteImport.update({
            id: '/policies',path: '/policies',getParentRoute: () => rootRouteImport
          })
const PlatformPoliciesRoute = PlatformPoliciesRouteImport.update({
            id: '/platform-policies',path: '/platform-policies',getParentRoute: () => rootRouteImport
          })
const PaymentSafetyRoute = PaymentSafetyRouteImport.update({
            id: '/payment-safety',path: '/payment-safety',getParentRoute: () => rootRouteImport
          })
const FeesRoute = FeesRouteImport.update({
            id: '/fees',path: '/fees',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const CreateOrderRoute = CreateOrderRouteImport.update({
            id: '/create-order',path: '/create-order',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const ConditionGuideRoute = ConditionGuideRouteImport.update({
            id: '/condition-guide',path: '/condition-guide',getParentRoute: () => rootRouteImport
          })
const BannedAccountsRoute = BannedAccountsRouteImport.update({
            id: '/banned-accounts',path: '/banned-accounts',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRouteRoute = AuthenticatedRouteRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const ProfileUsernameRoute = ProfileUsernameRouteImport.update({
            id: '/profile/$username',path: '/profile/$username',getParentRoute: () => rootRouteImport
          })
const OrdersIdRoute = OrdersIdRouteImport.update({
            id: '/orders/$id',path: '/orders/$id',getParentRoute: () => rootRouteImport
          })
const DemoIdRoute = DemoIdRouteImport.update({
            id: '/demo/$id',path: '/demo/$id',getParentRoute: () => rootRouteImport
          })
const AuthenticatedWishlistRoute = AuthenticatedWishlistRouteImport.update({
            id: '/wishlist',path: '/wishlist',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSoldItemsRoute = AuthenticatedSoldItemsRouteImport.update({
            id: '/sold-items',path: '/sold-items',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSellerVerificationRoute = AuthenticatedSellerVerificationRouteImport.update({
            id: '/seller-verification',path: '/seller-verification',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedSellerHubRoute = AuthenticatedSellerHubRouteImport.update({
            id: '/seller-hub',path: '/seller-hub',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedRecentlyViewedRoute = AuthenticatedRecentlyViewedRouteImport.update({
            id: '/recently-viewed',path: '/recently-viewed',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPurchasesRoute = AuthenticatedPurchasesRouteImport.update({
            id: '/purchases',path: '/purchases',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPriceAlertsRoute = AuthenticatedPriceAlertsRouteImport.update({
            id: '/price-alerts',path: '/price-alerts',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedPaymentsRoute = AuthenticatedPaymentsRouteImport.update({
            id: '/payments',path: '/payments',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedNotificationsRoute = AuthenticatedNotificationsRouteImport.update({
            id: '/notifications',path: '/notifications',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedMyListingsRoute = AuthenticatedMyListingsRouteImport.update({
            id: '/my-listings',path: '/my-listings',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedFulfillmentCartRoute = AuthenticatedFulfillmentCartRouteImport.update({
            id: '/fulfillment-cart',path: '/fulfillment-cart',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedDashboardRoute = AuthenticatedDashboardRouteImport.update({
            id: '/dashboard',path: '/dashboard',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedCollectionRoute = AuthenticatedCollectionRouteImport.update({
            id: '/collection',path: '/collection',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedBidsRoute = AuthenticatedBidsRouteImport.update({
            id: '/bids',path: '/bids',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedAccountRoute = AuthenticatedAccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedMessagesIndexRoute = AuthenticatedMessagesIndexRouteImport.update({
            id: '/messages/',path: '/messages/',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedTransactionIdRoute = AuthenticatedTransactionIdRouteImport.update({
            id: '/transaction/$id',path: '/transaction/$id',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedMessagesThreadIdRoute = AuthenticatedMessagesThreadIdRouteImport.update({
            id: '/messages/$threadId',path: '/messages/$threadId',getParentRoute: () => AuthenticatedRouteRoute
          })
const AuthenticatedCheckoutTransactionIdRoute = AuthenticatedCheckoutTransactionIdRouteImport.update({
            id: '/checkout/$transactionId',path: '/checkout/$transactionId',getParentRoute: () => AuthenticatedRouteRoute
          })





const AuthenticatedRouteRouteChildren = {
  AuthenticatedAccountRoute: AuthenticatedAccountRoute,AuthenticatedBidsRoute: AuthenticatedBidsRoute,AuthenticatedCollectionRoute: AuthenticatedCollectionRoute,AuthenticatedDashboardRoute: AuthenticatedDashboardRoute,AuthenticatedFulfillmentCartRoute: AuthenticatedFulfillmentCartRoute,AuthenticatedMyListingsRoute: AuthenticatedMyListingsRoute,AuthenticatedNotificationsRoute: AuthenticatedNotificationsRoute,AuthenticatedPaymentsRoute: AuthenticatedPaymentsRoute,AuthenticatedPriceAlertsRoute: AuthenticatedPriceAlertsRoute,AuthenticatedPurchasesRoute: AuthenticatedPurchasesRoute,AuthenticatedRecentlyViewedRoute: AuthenticatedRecentlyViewedRoute,AuthenticatedSellerHubRoute: AuthenticatedSellerHubRoute,AuthenticatedSellerVerificationRoute: AuthenticatedSellerVerificationRoute,AuthenticatedSoldItemsRoute: AuthenticatedSoldItemsRoute,AuthenticatedWishlistRoute: AuthenticatedWishlistRoute,AuthenticatedCheckoutTransactionIdRoute: AuthenticatedCheckoutTransactionIdRoute,AuthenticatedMessagesThreadIdRoute: AuthenticatedMessagesThreadIdRoute,AuthenticatedTransactionIdRoute: AuthenticatedTransactionIdRoute,AuthenticatedMessagesIndexRoute: AuthenticatedMessagesIndexRoute
}

const AuthenticatedRouteRouteWithChildren = AuthenticatedRouteRoute._addFileChildren(AuthenticatedRouteRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AuthenticatedRouteRoute: AuthenticatedRouteRouteWithChildren,AboutRoute: AboutRoute,AdminRoute: AdminRoute,AuthRoute: AuthRoute,BannedAccountsRoute: BannedAccountsRoute,ConditionGuideRoute: ConditionGuideRoute,ContactRoute: ContactRoute,CreateOrderRoute: CreateOrderRoute,FaqRoute: FaqRoute,FeesRoute: FeesRoute,PaymentSafetyRoute: PaymentSafetyRoute,PlatformPoliciesRoute: PlatformPoliciesRoute,PoliciesRoute: PoliciesRoute,RatingPolicyRoute: RatingPolicyRoute,ResetPasswordRoute: ResetPasswordRoute,SellerPolicyRoute: SellerPolicyRoute,TermsRoute: TermsRoute,TrustRoute: TrustRoute,VerifiedStoresRoute: VerifiedStoresRoute,WtbOpsControlRoute: WtbOpsControlRoute,DemoIdRoute: DemoIdRoute,OrdersIdRoute: OrdersIdRoute,ProfileUsernameRoute: ProfileUsernameRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)